import { SITE_URL } from '../../constants'
import { buildCaseStudySchema } from '../../builders/caseStudy'
import { PageMeta } from '../../types'

const description = "顧客理解を深めるワークショップを実施しました。このワークショップはJOB理論に基づき、顧客が成し遂げたいことを明確にしました。これをもとに、ソリューションアイデアの創出まで実施しました。"

const primaryImage = "https://www.i3design.jp/ogp_logo.png"

export const andoPageMeta: PageMeta = {
  title: "JOB理論1dayワークショップ | 事例 | i3DESIGN アイスリーデザイン",
  description,
  keyword: "DX戦略 組織開発 人材育成 生成AI デジタルトランスフォーメーション",
  image: primaryImage,
  url: `${SITE_URL}/cases/ando/`,
}

export const andoSchema = buildCaseStudySchema({
  slug: "ando",
  pageTitle: andoPageMeta.title,
  description: andoPageMeta.description,
  headline: "JOB理論1dayワークショップ",
  alternativeHeadline: "株式会社安藤・間",
  primaryImage,
  images: ["https://www.i3design.jp/ogp_logo.png","https://www.i3design.jp/images/img/cases/caseStudyTop/ando.webp"],
  clientName: "株式会社安藤・間",
  breadcrumbLabel: "JOB理論1dayワークショップ",
})
